export const ANALYTICS_CONTEXT = "Collection Landing";
